(function () {
  'use strict';

  const VF_API_BASE = 'https://virtual-fitter-api-production.up.railway.app';
  const RENDER_MODE = 'ai_premium';
  const BOOTSTRAP_CONFIG = window.VirtualFitterConfig;

  if (!BOOTSTRAP_CONFIG) {
    return;
  }

  if (!BOOTSTRAP_CONFIG.productId || !BOOTSTRAP_CONFIG.productImageUrl) {
    console.warn('[VirtualFitter] Missing required config (productId or productImageUrl). Aborting.');
    return;
  }

  console.log(
    '[VirtualFitter] Initialised for:',
    BOOTSTRAP_CONFIG.productTitle || 'Unknown product',
    '(' + (BOOTSTRAP_CONFIG.productHandle || 'no-handle') + ')'
  );
  console.log('[VirtualFitter] Product image:', BOOTSTRAP_CONFIG.productImageUrl);
  console.log('[VirtualFitter] Product type:', BOOTSTRAP_CONFIG.productType || 'unknown');

  function joinUrl(base, path) {
    return String(base || '').replace(/\/$/, '') + path;
  }

  function initVirtualFitter(root) {
    if (!root || root.dataset.ksVfReady === 'true') {
      return;
    }

    const configNode = root.querySelector('[data-ks-virtual-fitter-config]');
    if (!configNode) {
      return;
    }

    let config = {};

    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      console.error('Virtual fitter config parsing failed.', error);
      return;
    }

    config = Object.assign({}, config, BOOTSTRAP_CONFIG, window.KSVirtualFitterOverrides || {});

    const apiBase = config.apiBaseUrl || config.apiBase || VF_API_BASE;
    config.apiBase = apiBase;
    config.apiBaseUrl = apiBase;

    if (!config.createJobUrl) {
      config.createJobUrl = joinUrl(apiBase, '/v1/render-jobs');
    }
    if (!config.jobStatusBaseUrl) {
      config.jobStatusBaseUrl = joinUrl(apiBase, '/v1/render-jobs');
    }
    root.dataset.ksVfReady = 'true';

    const modal = root.querySelector('[data-ks-vf-modal]');
    const fileInput = root.querySelector('[data-ks-vf-file]');
    const submitButton = root.querySelector('[data-ks-vf-submit]');
    const resetButton = root.querySelector('[data-ks-vf-reset]');
    const inputPreview = root.querySelector('[data-ks-vf-input-preview]');
    const inputPlaceholder = root.querySelector('[data-ks-vf-input-placeholder]');
    const resultPreview = root.querySelector('[data-ks-vf-result-preview]');
    const resultPlaceholder = root.querySelector('[data-ks-vf-result-placeholder]');
    const resultMeta = root.querySelector('[data-ks-vf-result-meta]');
    const status = root.querySelector('[data-ks-vf-status]');
    const insights = root.querySelector('[data-ks-vf-insights]');

    let selectedFile = null;
    let activePoller = null;
    const renderMode = RENDER_MODE;
    let bodyScrollPosition = 0;
    let hiddenPopupNodes = [];

    function normalizeJobPayload(payload) {
      return payload && payload.job ? payload.job : payload;
    }

    function extractErrorMessage(payload) {
      const job = normalizeJobPayload(payload || {});
      const error = job && job.error ? job.error : payload && payload.error ? payload.error : null;

      if (error && typeof error === 'object') {
        return error.message || error.technical_message || error.detail || 'Virtual fitter request failed.';
      }

      if (typeof error === 'string' && error.trim()) {
        return error;
      }

      if (payload && typeof payload.message === 'string' && payload.message.trim()) {
        return payload.message;
      }

      return 'Virtual fitter request failed.';
    }

    function getResultImageUrl(result) {
      if (!result) {
        return '';
      }

      return result.result_url || result.image_url || '';
    }

    function lockBodyScroll() {
      if (document.body.classList.contains('ks-virtual-fitter-open')) {
        return;
      }

      bodyScrollPosition = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('ks-virtual-fitter-open');
      document.body.classList.add('vf-modal-open');
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + bodyScrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    function unlockBodyScroll() {
      if (!document.body.classList.contains('ks-virtual-fitter-open')) {
        return;
      }

      document.body.classList.remove('ks-virtual-fitter-open');
      document.body.classList.remove('vf-modal-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, bodyScrollPosition || 0);
    }

    function restoreHiddenPopups() {
      hiddenPopupNodes.forEach(function (entry) {
        if (!entry || !entry.node) {
          return;
        }

        if (entry.styleAttr === null) {
          entry.node.removeAttribute('style');
        } else {
          entry.node.setAttribute('style', entry.styleAttr);
        }
      });

      hiddenPopupNodes = [];
    }

    function forceHidePopups() {
      const popupSelectors = [
        '[class*="selling"]',
        '[class*="Selling"]',
        '[class*="SELLING"]',
        '[class*="offer"]',
        '[class*="Offer"]',
        '[class*="popup"]',
        '[class*="Popup"]',
        '[class*="notification"]',
        '[class*="toast"]',
        '.needsclick',
        '[data-selling-fast]'
      ].join(', ');

      document.querySelectorAll(popupSelectors).forEach(function (element) {
        const alreadyTracked = hiddenPopupNodes.some(function (entry) {
          return entry.node === element;
        });

        if (!alreadyTracked) {
          hiddenPopupNodes.push({
            node: element,
            styleAttr: element.getAttribute('style')
          });
        }

        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('visibility', 'hidden', 'important');
        element.style.setProperty('opacity', '0', 'important');
        element.style.setProperty('z-index', '-9999', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      });

      document.querySelectorAll('iframe').forEach(function (iframe) {
        const src = iframe.getAttribute('src') || '';
        if (src.indexOf('popup') === -1 && src.indexOf('offer') === -1) {
          return;
        }

        const alreadyTracked = hiddenPopupNodes.some(function (entry) {
          return entry.node === iframe;
        });

        if (!alreadyTracked) {
          hiddenPopupNodes.push({
            node: iframe,
            styleAttr: iframe.getAttribute('style')
          });
        }

        iframe.style.setProperty('display', 'none', 'important');
        iframe.style.setProperty('visibility', 'hidden', 'important');
        iframe.style.setProperty('opacity', '0', 'important');
        iframe.style.setProperty('z-index', '-9999', 'important');
        iframe.style.setProperty('pointer-events', 'none', 'important');
      });
    }

    function setStatus(message, state, progress) {
      if (!status) {
        return;
      }

      const prefix = typeof progress === 'number' ? '[' + Math.max(0, Math.min(progress, 100)) + '%] ' : '';
      status.textContent = prefix + (message || 'Working on your preview.');

      if (state) {
        status.dataset.state = state;
      } else {
        delete status.dataset.state;
      }
    }

    function setInsights(items) {
      if (!insights) {
        return;
      }

      if (!items || !items.length) {
        insights.hidden = true;
        insights.innerHTML = '';
        return;
      }

      insights.hidden = false;
      insights.innerHTML = items
        .map(function (item) {
          const tone = item.tone || 'warning';
          const title = item.title ? '<strong>' + item.title + '</strong>' : '';
          const message = item.message || '';
          return '<div class="ks-virtual-fitter__insight" data-tone="' + tone + '">' + title + '<span>' + message + '</span></div>';
        })
        .join('');
    }

    function setResultMeta(result) {
      if (!resultMeta) {
        return;
      }

      const imageUrl = getResultImageUrl(result);
      if (!imageUrl) {
        resultMeta.hidden = true;
        resultMeta.innerHTML = '';
        return;
      }

      resultMeta.hidden = false;
      resultMeta.innerHTML =
        '<div class="ks-virtual-fitter__meta-actions">' +
        '<button type="button" class="ks-virtual-fitter__download-btn" data-ks-vf-download="' + imageUrl + '">Download Preview</button>' +
        '</div>' +
        '<div class="ks-virtual-fitter__disclaimer" data-ks-vf-disclaimer>' +
        '<div class="ks-virtual-fitter__disclaimer-icon">ℹ️</div>' +
        '<div class="ks-virtual-fitter__disclaimer-copy">' +
        '<p><strong>Just so you know...</strong></p>' +
        '<p>This is an AI-generated preview to give you a rough idea of how the part might look. It is not pixel-perfect, and final fitment may vary depending on your exact vehicle.</p>' +
        '<p>For the proper finish, <button type="button" class="ks-virtual-fitter__book-appointment-btn" data-ks-vf-book-appointment aria-label="Book a fitting appointment">book a fitting appointment</button> and we will make sure everything is spot on.</p>' +
        '</div>' +
        '<button type="button" class="ks-virtual-fitter__disclaimer-close" data-ks-vf-dismiss-disclaimer>Got it, cheers!</button>' +
        '</div>';
    }

    function formatAngle(angle) {
      const names = {
        rear: 'Rear',
        front: 'Front',
        side: 'Side',
        three_quarter: '3/4 Angle',
        side_left: 'Left Side',
        side_right: 'Right Side'
      };

      return names[angle] || String(angle || '').replace(/_/g, ' ');
    }

    function getErrorIcon(errorCode) {
      const icons = {
        VF_001:
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ks-virtual-fitter__error-svg">' +
          '<circle cx="12" cy="12" r="10"></circle><path d="M12 8v4M12 16h.01"></path></svg>',
        VF_002:
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ks-virtual-fitter__error-svg">' +
          '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>',
        VF_003:
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ks-virtual-fitter__error-svg">' +
          '<rect x="3" y="3" width="18" height="18" rx="2"></rect><path d="M8 8l8 8M16 8l-8 8"></path></svg>'
      };

      return icons[errorCode] || icons.VF_001;
    }

    function displayError(payload) {
      if (!insights) {
        return;
      }

      const error = payload && payload.error ? payload.error : {};
      const metadata = payload && payload.metadata ? payload.metadata : {};
      const guidance = payload && payload.guidance ? payload.guidance : metadata.user_guidance;
      const detected = payload && payload.detected ? payload.detected : metadata.detected;

      if (!guidance) {
        setInsights(buildInsightsFromJob(payload));
        return;
      }

      insights.hidden = false;
      insights.innerHTML =
        '<div class="ks-virtual-fitter__error-card" data-code="' + (error.code || 'VF_001') + '">' +
        '<div class="ks-virtual-fitter__error-icon" data-code="' + (error.code || 'VF_001') + '">' + getErrorIcon(error.code || 'VF_001') + '</div>' +
        '<h4 class="ks-virtual-fitter__error-title">' + guidance.title + '</h4>' +
        '<p class="ks-virtual-fitter__error-message">' + guidance.message + '</p>' +
        (
          detected && detected.angle
            ? '<div class="ks-virtual-fitter__error-detected"><span>We detected</span><strong>' + formatAngle(detected.angle) + ' view</strong></div>'
            : ''
        ) +
        '<div class="ks-virtual-fitter__error-tips">' +
        '<p class="ks-virtual-fitter__error-subtitle">How to fix it</p>' +
        '<ul class="ks-virtual-fitter__error-list">' +
        (guidance.tips || []).map(function (tip) { return '<li>' + tip + '</li>'; }).join('') +
        '</ul></div>' +
        '<div class="ks-virtual-fitter__error-angles">' +
        '<p class="ks-virtual-fitter__error-subtitle">Best angles for this product</p>' +
        '<div class="ks-virtual-fitter__error-badges">' +
        (guidance.required_angles || []).map(function (angle) {
          return '<span class="ks-virtual-fitter__error-badge">' + formatAngle(angle) + '</span>';
        }).join('') +
        '</div></div>' +
        (
          guidance.example_description
            ? '<p class="ks-virtual-fitter__error-example">' + guidance.example_description + '</p>'
            : ''
        ) +
        '<div class="ks-virtual-fitter__error-actions">' +
        '<button type="button" class="ks-virtual-fitter__primary" data-ks-vf-error-retry>Try Another Photo</button>' +
        '<button type="button" class="ks-virtual-fitter__secondary" data-ks-vf-close>Close</button>' +
        '</div>' +
        '</div>';

      if (resetButton) {
        resetButton.hidden = false;
      }
    }

    function openModal() {
      if (!modal) {
        return;
      }

      lockBodyScroll();
      forceHidePopups();
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      console.log('[VirtualFitter] Selected render mode:', renderMode);
      window.setTimeout(function () {
        if (modal && !modal.hidden) {
          forceHidePopups();
        }
      }, 150);
      window.setTimeout(function () {
        if (modal && !modal.hidden) {
          forceHidePopups();
        }
      }, 800);
    }

    function closeModal() {
      if (!modal) {
        return;
      }

      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      restoreHiddenPopups();
      unlockBodyScroll();
    }

    function resetResult() {
      if (resultPreview) {
        resultPreview.hidden = true;
        resultPreview.removeAttribute('src');
        resultPreview.classList.remove('is-zoomable');
      }

      if (resultPlaceholder) {
        resultPlaceholder.hidden = false;
      }

      setResultMeta(null);
    }

    function showResult(url) {
      if (!resultPreview) {
        return;
      }

      resultPreview.src = url;
      resultPreview.hidden = false;
      resultPreview.classList.add('is-zoomable');

      if (resultPlaceholder) {
        resultPlaceholder.hidden = true;
      }

      initPreviewLightbox();
    }

    function downloadPreview(url) {
      if (!url) {
        return;
      }

      fetch(url)
        .then(function (response) {
          return response.blob();
        })
        .then(function (blob) {
          const objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = objectUrl;
          link.download = 'virtual-fitter-preview-' + Date.now() + '.jpg';
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(objectUrl);
        })
        .catch(function () {
          const link = document.createElement('a');
          link.href = url;
          link.download = 'virtual-fitter-preview.jpg';
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    }

    function triggerAppointmentBooking() {
      var appointoButton = document.querySelector('#appointo-btn');
      if (appointoButton) {
        appointoButton.click();
        return;
      }

      if (typeof window.openAppointoModal === 'function') {
        window.openAppointoModal();
        return;
      }

      var bookingElement = document.querySelector('[class*="schedule"], [class*="appointment"], [class*="booking"], [data-appointment]');
      if (bookingElement) {
        bookingElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        bookingElement.click();
        return;
      }

      var appointmentSection = document.querySelector('.appointo-section, #appointment-section');
      if (appointmentSection) {
        appointmentSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (window.Appointo && typeof window.Appointo.open === 'function') {
        window.Appointo.open();
        return;
      }

      window.location.href = '/pages/contact';
    }

    function closeLightbox(lightbox) {
      if (!lightbox) {
        return;
      }

      lightbox.classList.remove('ks-virtual-fitter__lightbox--open');
      window.setTimeout(function () {
        lightbox.remove();
      }, 240);
    }

    function openLightbox(imageUrl) {
      if (!imageUrl) {
        return;
      }

      const existingLightbox = document.querySelector('.ks-virtual-fitter__lightbox');
      if (existingLightbox) {
        existingLightbox.remove();
      }

      const lightbox = document.createElement('div');
      lightbox.className = 'ks-virtual-fitter__lightbox';
      lightbox.innerHTML =
        '<div class="ks-virtual-fitter__lightbox-backdrop"></div>' +
        '<div class="ks-virtual-fitter__lightbox-content">' +
        '<button type="button" class="ks-virtual-fitter__lightbox-close" aria-label="Close preview">&times;</button>' +
        '<img src="' + imageUrl + '" alt="Virtual fitter preview" class="ks-virtual-fitter__lightbox-image">' +
        '<div class="ks-virtual-fitter__lightbox-actions">' +
        '<button type="button" class="ks-virtual-fitter__primary ks-virtual-fitter__lightbox-download">Download Preview</button>' +
        '</div>' +
        '</div>';

      document.body.appendChild(lightbox);

      const escHandler = function (event) {
        if (event.key === 'Escape') {
          closeLightbox(lightbox);
          document.removeEventListener('keydown', escHandler);
        }
      };

      lightbox.querySelector('.ks-virtual-fitter__lightbox-backdrop').addEventListener('click', function () {
        closeLightbox(lightbox);
        document.removeEventListener('keydown', escHandler);
      });
      lightbox.querySelector('.ks-virtual-fitter__lightbox-close').addEventListener('click', function () {
        closeLightbox(lightbox);
        document.removeEventListener('keydown', escHandler);
      });
      lightbox.querySelector('.ks-virtual-fitter__lightbox-download').addEventListener('click', function () {
        downloadPreview(imageUrl);
      });
      document.addEventListener('keydown', escHandler);

      window.requestAnimationFrame(function () {
        lightbox.classList.add('ks-virtual-fitter__lightbox--open');
      });
    }

    function initPreviewLightbox() {
      if (!resultPreview || resultPreview.dataset.ksVfLightboxBound === 'true') {
        return;
      }

      resultPreview.dataset.ksVfLightboxBound = 'true';
      resultPreview.addEventListener('click', function () {
        if (resultPreview.src) {
          openLightbox(resultPreview.src);
        }
      });
    }

    function clearInputPreview() {
      if (inputPreview) {
        inputPreview.hidden = true;
        inputPreview.removeAttribute('src');
      }

      if (inputPlaceholder) {
        inputPlaceholder.hidden = false;
      }
    }

    function showInputPreview(file) {
      if (!inputPreview || !file) {
        return;
      }

      const objectUrl = URL.createObjectURL(file);
      inputPreview.src = objectUrl;
      inputPreview.hidden = false;

      if (inputPlaceholder) {
        inputPlaceholder.hidden = true;
      }
    }

    function updateSubmitState() {
      if (!submitButton) {
        return;
      }

      submitButton.disabled = !selectedFile;
    }

    async function fetchJson(url, options) {
      console.log('[VirtualFitter] Fetch', url, options && options.method ? options.method : 'GET');
      const response = await fetch(url, options);
      let payload = {};

      try {
        payload = await response.json();
      } catch (error) {
        payload = {};
      }

      console.log('[VirtualFitter] Response', response.status, payload);

      if (!response.ok) {
        const message = extractErrorMessage(payload);
        const requestError = new Error(message);
        requestError.payload = payload;
        throw requestError;
      }

      return payload;
    }

    function stopPolling() {
      if (activePoller) {
        window.clearTimeout(activePoller);
        activePoller = null;
      }
    }

    function buildInsightsFromJob(job) {
      const items = [];

      if (job && Array.isArray(job.warnings)) {
        job.warnings.forEach(function (warning) {
          items.push({
            tone: 'warning',
            title: warning.code || 'Tip',
            message: warning.message,
          });
        });
      }

      if (job && job.result && job.result.placement_quality === 'low') {
        items.push({
          tone: 'warning',
          title: 'Retry Suggestion',
          message: 'A matching side or rear angle photo should improve fit quality for this product.',
        });
      }

      if (job && job.error) {
        items.unshift({
          tone: 'error',
          title: job.error.code || 'Virtual Fitter',
          message: job.error.message,
        });
      }

      if (job && job.metadata && job.metadata.guidance) {
        items.push({
          tone: job.error ? 'error' : 'warning',
          title: 'How to Fix It',
          message: job.metadata.guidance,
        });
      }

      return items;
    }

    function applyJobUpdate(rawPayload) {
      const job = normalizeJobPayload(rawPayload || {});
      const statusValue = job.status || 'pending';
      const message = job.message || 'Working on your preview.';
      const resultImageUrl = getResultImageUrl(job.result);

      if (resultImageUrl) {
        showResult(resultImageUrl);
      }

      setResultMeta(job.result || null);
      setInsights(buildInsightsFromJob(job));

      if (resetButton) {
        resetButton.hidden = !(statusValue === 'complete' || statusValue === 'failed');
      }

      if (statusValue === 'complete') {
        setStatus(message, 'success', job.progress);
      } else if (statusValue === 'failed') {
        if (job.metadata && job.metadata.user_guidance) {
          setStatus(job.metadata.user_guidance.title || (job.error && job.error.message) || message, 'error', job.progress);
          displayError({
            error: job.error || {},
            guidance: job.metadata.user_guidance,
            detected: job.metadata.detected || {}
          });
        } else {
          setStatus((job.error && job.error.message) || message, 'error', job.progress);
        }
      } else {
        setStatus(message, null, job.progress);
      }

      return job;
    }

    function resetFlow() {
      stopPolling();
      selectedFile = null;
      if (fileInput) {
        fileInput.value = '';
      }
      clearInputPreview();
      resetResult();
      setInsights([]);
      setStatus('Add a photo to start your preview.', null);
      updateSubmitState();
      if (resetButton) {
        resetButton.hidden = true;
      }
      if (submitButton) {
        submitButton.textContent = 'Generate Preview';
      }
    }

    function pollJob(jobId) {
      stopPolling();

      if (!config.jobStatusBaseUrl) {
        setStatus('Preview job created, but no job status URL is configured.', 'error');
        return;
      }

      const poll = async function () {
        try {
          const payload = await fetchJson(config.jobStatusBaseUrl + '/' + encodeURIComponent(jobId), {
            method: 'GET',
            headers: {
              Accept: 'application/json'
            }
          });

          const job = applyJobUpdate(payload);

          if (job.status === 'complete' || job.status === 'failed') {
            stopPolling();
            return;
          }

          activePoller = window.setTimeout(poll, 1800);
        } catch (error) {
          setStatus(error.message || 'We could not fetch the preview status.', 'error');
          setInsights([
            {
              tone: 'error',
              title: 'Status check failed',
              message: 'The render job may still be running. Try again in a few seconds.',
            }
          ]);
          stopPolling();
        }
      };

      poll();
    }

    async function submitJob() {
      if (!selectedFile) {
        setStatus('Add a vehicle photo before generating a preview.', 'error');
        return;
      }

      if (!config.createJobUrl) {
        setStatus('No Virtual Fitter API endpoint is configured yet.', 'error');
        return;
      }

      const formData = new FormData();
      const productImageUrl = config.productImageUrl || '';

      console.log('[VirtualFitter] Submitting job:');
      console.log('  Product ID:', config.productId);
      console.log('  Product Handle:', config.productHandle || '');
      console.log('  Product Image URL:', productImageUrl);
      console.log('  Product Type:', config.productType || '');

      if (!productImageUrl) {
        console.error('[VirtualFitter] No product image URL found.');
        setStatus('Product image not available for this item.', 'error');
        setInsights([{
          title: 'Product image missing',
          message: 'We could not find the main product image for this item yet.',
          tone: 'warning'
        }]);
        return;
      }

      console.log('[VirtualFitter] Submitting render job', {
        productId: config.productId,
        variantId: config.variantId,
        renderMode: renderMode,
        hasOverlay: !!config.overlayAssetUrl,
        hasProductImage: !!productImageUrl,
        hasMask: !!config.maskAssetUrl,
        fileName: selectedFile.name,
        fileSize: selectedFile.size
      });
      formData.append('photo', selectedFile);
      formData.append('shop_domain', String(config.shopDomain || ''));
      formData.append('product_id', String(config.productId || ''));
      formData.append('product_handle', String(config.productHandle || ''));
      formData.append('product_title', String(config.productTitle || ''));
      formData.append('product_type', String(config.productType || ''));
      formData.append('variant_id', String(config.variantId || ''));
      formData.append('variant_title', String(config.variantTitle || ''));
      formData.append('placement_hint', String(config.placementHint || 'automotive accessory'));
      formData.append('product_image_url', String(productImageUrl || ''));
      formData.append('featured_image_url', String(config.featuredImage || ''));
      formData.append('render_mode', RENDER_MODE);

      if (config.overlayAssetUrl) {
        formData.append('overlay_asset_url', config.overlayAssetUrl);
      }

      if (config.maskAssetUrl) {
        formData.append('mask_asset_url', config.maskAssetUrl);
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Generating...';
      }

      resetResult();
      setInsights([]);
      setStatus('Uploading your photo and creating your KITS STYLE AI preview...', null, 5);

      try {
        const payload = await fetchJson(config.createJobUrl, {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json'
          }
        });

        const job = applyJobUpdate(payload);

        if (job.status === 'complete' || job.status === 'failed') {
          return;
        }

        pollJob(job.job_id);
      } catch (error) {
        console.error('[VirtualFitter] Render request failed', error, error && error.payload ? error.payload : null);
        if (error && error.payload && error.payload.guidance) {
          setStatus(error.payload.guidance.title || error.message || 'The preview could not be generated.', 'error');
          displayError(error.payload);
        } else {
          setStatus(error.message || 'The preview could not be generated.', 'error');
          setInsights([
            {
              tone: 'error',
              title: error && error.payload && error.payload.error && error.payload.error.code ? error.payload.error.code : 'Preview failed',
              message: error.message || 'Try another image with the full vehicle visible.',
            }
          ]);
        }
        if (resetButton) {
          resetButton.hidden = false;
        }
      } finally {
        if (submitButton) {
          submitButton.textContent = 'Generate Preview';
          updateSubmitState();
        }
      }
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-ks-vf-open]')) {
        openModal();
      }

      const downloadButton = event.target.closest('[data-ks-vf-download]');
      if (downloadButton) {
        downloadPreview(downloadButton.getAttribute('data-ks-vf-download') || '');
      }

      const bookAppointmentLink = event.target.closest('[data-ks-vf-book-appointment]');
      if (bookAppointmentLink) {
        event.preventDefault();
        triggerAppointmentBooking();
      }

      const disclaimerClose = event.target.closest('[data-ks-vf-dismiss-disclaimer]');
      if (disclaimerClose) {
        const disclaimer = disclaimerClose.closest('[data-ks-vf-disclaimer]');
        if (disclaimer) {
          disclaimer.remove();
        }
      }

      if (event.target.closest('[data-ks-vf-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) {
        closeModal();
      }
    });

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        selectedFile = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;

        if (selectedFile) {
          showInputPreview(selectedFile);
          setStatus('Photo ready. Generate a preview to start segmentation and placement.', null);
        } else {
          setStatus('Add a photo to start your preview.', null);
        }

        resetResult();
        setInsights([]);
        if (resetButton) {
          resetButton.hidden = true;
        }
        updateSubmitState();
      });
    }

    if (submitButton) {
      submitButton.addEventListener('click', function () {
        submitJob();
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        resetFlow();
      });
    }

    if (insights) {
      insights.addEventListener('click', function (event) {
        if (event.target.closest('[data-ks-vf-error-retry]')) {
          resetFlow();
        }
      });
    }

    updateSubmitState();
  }

  function initAll() {
    document.querySelectorAll('[data-ks-virtual-fitter]').forEach(initVirtualFitter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver(function () {
    initAll();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
